import IconArrowRight from 'assets/icons/arrow-right-alt.svg';
import cn from 'classnames';
import Button from 'components/button-new';
import {
  AllergySegmentationIds,
  Segmentation,
  SegmentationIds,
} from 'constants/segmentation';
import { possibleTags } from 'interfaces/collection-filter';
import { FormattedMessage } from 'react-intl';
import { gtm, selectElement } from 'tracking';
import { mapAllergyTagsToSegmentationIds } from '../utils';

interface PropTypes {
  actualSegment?: Segmentation;
  isProfileMinimal: boolean;
  temporarySelectedAllergies?: possibleTags[];
  updatePetProfile: (
    segmentation: SegmentationIds | undefined,
    allergies?: AllergySegmentationIds[]
  ) => void;
  collectionHandle: string;
}

/**
 * Button that redirects the user to the pet profile page.
 * Used on the PetProfileCollectionSelector component.
 */
const ProfileButton: React.FC<PropTypes> = ({
  actualSegment,
  isProfileMinimal,
  temporarySelectedAllergies,
  updatePetProfile,
  collectionHandle,
}) => {
  return (
    <Button
      size="base"
      className={cn(
        'mt-4 lg:mt-0 lg:max-w-72',
        isProfileMinimal ? '' : 'w-2/3!'
      )}
      onClick={() => {
        gtm(
          selectElement({
            element: [
              'Pet Profile Selector',
              collectionHandle,
              isProfileMinimal ? 'New Profile' : 'Edit Profile',
            ],
          })
        );
        actualSegment &&
          updatePetProfile(
            actualSegment.id,
            mapAllergyTagsToSegmentationIds(temporarySelectedAllergies)
          );
      }}
      href={`/pet-profile${isProfileMinimal ? '?edit=true' : ''}`}
    >
      <span className="flex items-center gap-1.5">
        {isProfileMinimal ? (
          <FormattedMessage
            id={`cdp:pet-profile:selector:cta-minimal-profile:${actualSegment ? 'segment' : 'generic'}-cdp`}
          />
        ) : (
          <FormattedMessage id="cdp:pet-profile:selector:cta-extended-profile" />
        )}

        {isProfileMinimal && <IconArrowRight className="h-5 w-5 shrink-0" />}
      </span>
    </Button>
  );
};

export default ProfileButton;
